import { WebGLRenderer, ACESFilmicToneMapping } from 'three'

/*****************************************************************
 * Renderer HANDLER
 * ***************************************************************/

/**
 * Provide WebGLRenderer
 * @param {string} name
 * @param {*} canvas
 * @returns WebGLRenderer
 */
export const buildRender = (name, canvas, snapshot = false, dimension = false ) => {
    const renderer = new WebGLRenderer( { antialias: true, alpha: true, logarithmicDepthBuffer: false, depth: true } )
    renderer.domElement.id = name
    renderer.preserveDrawingBuffer = snapshot
    renderer.physicallyCorrectLights = true
    renderer.toneMapping = ACESFilmicToneMapping
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.setSize( dimension ? dimension.offsetWidth : canvas.offsetWidth, dimension ? dimension.offsetHeight : canvas.offsetHeight)
    canvas.appendChild(renderer.domElement)
    return renderer
  }

/**
 * Renderer Setter
 * @param {object} renderer
 * @param {number} left
 * @param {number} right
 * @param {number} width
 * @param {number} height
 */
export const rendererFormat =  (renderer, left, bottom, width, height) => {
    renderer.setViewport( left, bottom, width, height )
    renderer.setScissor( left, bottom, width, height )
    renderer.setScissorTest ( true )
}
